// src/app/models/press-release.ts

export interface PressRelease {
  id: string;

  /**
   * Permanent SEO-friendly URL segment.
   *
   * Add this when a headline may change after publication;
   * otherwise it is derived deterministically from the
   * publication date and title.
   */
  slug?: string;

  title: string;

  date: Date;

  summary: string;

  content: string;

  /**
   * Optional image used for:
   * - Open Graph previews
   * - X/Twitter cards
   * - NewsArticle structured data
   * - Press release social sharing
   */
  image?: string;

  /**
   * Optional link to the full press release.
   */
  link?: string;
}

export function createPressReleaseSlug(
  release: PressRelease
): string {

  if (release.slug) {
    return release.slug;
  }

  const year =
    release.date.getFullYear();

  const month =
    String(release.date.getMonth() + 1)
      .padStart(2, '0');

  const day =
    String(release.date.getDate())
      .padStart(2, '0');

  const titleSlug =
    release.title
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()

      // Remove apostrophes
      .replace(/['’]/g, '')

      // Collapse common multi-letter abbreviations
      // such as "U.S." -> "US"
      .replace(/\b(?:[a-z]\.){2,}/g, value =>
        value.replace(/\./g, '')
      )

      // Convert everything else into hyphens
      .replace(/[^a-z0-9]+/g, '-')

      // Remove leading/trailing hyphens
      .replace(/^-+|-+$/g, '');

  return `${year}-${month}-${day}-${titleSlug}`;
}